module.exports = __webpack_public_path__ + "static/media/bebedouro_suspenso_freshwall.94565c43.jpg";